<template>
  <div v-if="activeTab === 'router'">
    <div
      v-if="internalWorkflows.length > 0 || externalWorkflows.length > 0"
      class="card card-outline-primary rounded-3 shadow"
    >
      <div class="card-body p-0 px-4 py-3">
        <div class="d-flex justify-content-between align-items-center">
          <ul class="card-progress-tracker fw-bold text-center mb-0">
            <li
              :class="
                workflowData &&
                workflowData.workflow_completed &&
                workflowData.workflow_completed.workflow_services_exist
                  ? 'completed'
                  : 'in-completed'
              "
            >
              Workflow Router
            </li>
          </ul>
        </div>
        <transition name="slide-fade">
          <div class="row">
            <hr class="fw-light" />
            <div class="col-12 mb-2" v-if="internalWorkflows.length > 0">
              <div class="card rounded-3">
                <div class="card-body">
                  <h5 class="fw-bold small text-muted mb-3">
                    <i class="bi bi-house-door-fill me-2"></i>
                    Internal Workflows
                  </h5>
                  <div class="row g-3">
                    <div
                      class="col-md-6 col-lg-4"
                      v-for="workflow in internalWorkflows"
                      :key="workflow.id"
                    >
                      <div class="workflow-card p-3 border rounded-3 h-100">
                        <div class="d-flex flex-column align-items-center mb-3">
                          <div class="workflow-icon mb-1">
                            <i class="bi bi-diagram-3-fill text-primary"></i>
                          </div>
                          <div class="text-center">
                            <h6 class="fw-bold mb-1">
                              {{ workflow.router_name }}
                            </h6>
                            <small class="text-muted">{{
                              workflow.workflow_name
                            }}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mb-2" v-if="externalWorkflows.length > 0">
              <div class="card rounded-3">
                <div class="card-body">
                  <h5 class="fw-bold small text-muted mb-3">
                    <i class="bi bi-link-45deg me-2"></i>
                    External Workflows
                  </h5>
                  <div class="row g-3">
                    <div
                      class="col-md-6 col-lg-4"
                      v-for="workflow in externalWorkflows"
                      :key="workflow.id"
                    >
                      <div class="workflow-card p-3 border rounded-3 h-100">
                        <div class="d-flex flex-column align-items-center mb-3">
                          <div class="workflow-icon mb-1">
                            <i class="bi bi-globe text-info"></i>
                          </div>
                          <div class="text-center">
                            <h6 class="fw-bold mb-1">
                              {{ workflow.router_name }}
                            </h6>
                            <small class="text-muted">External Link</small>
                          </div>
                        </div>
                        <div class="external-link">
                          <button
                            @click="
                              window.open(workflow.external_url, '_blank')
                            "
                            class="btn btn-bg-green btn-sm text-xs rounded"
                          >
                            <i class="bi bi-box-arrow-up-right me-1"></i>
                            Open Link
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RouterTab",
  props: {
    activeTab: {
      type: String,
      default: "router",
    },
    workflowData: {
      type: Object,
      default: null,
    },
    internalWorkflows: {
      type: Array,
      default: () => [],
    },
    externalWorkflows: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openModal(service) {
      this.$emit("open-modal", service);
    },
  },
};
</script>

<style scoped>
.workflow-icon {
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.workflow-icon i {
  font-size: 2rem;
  color: var(--primary-color);
}

.services-list .badge {
  font-size: 0.75rem;
}

.external-link .btn {
  width: 100%;
}
</style>
